import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class AuthorService {
  constructor(private restService: RestService) {}

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('authors/search', val_params);
  }

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('authors/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('authors/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('authors/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('authors/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('authors/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('authors/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('authors/delete', val_id);
  }
}
